/**
 * JQuery
 */

import $ from "jquery";

window.jQuery = $;
window.$ = $;

/**
 * Bootstrap
 */

import {
  Alert,       // Dismissible alerts
  // Button,      // Toggle button states
  // Carousel,    // Slideshow component
  // Collapse, // Accordion-like collapsing elements
  // Dropdown,    // Dropdown menus
  Modal,       // Popup modals
  // Offcanvas,   // Offcanvas sidebars
  // Popover,     // Pop-up content on hover/click (requires @popperjs/core)
  // ScrollSpy,   // Auto-updating navigation based on scroll position
  // Tab,         // Tabs and pills navigation
  // Toast,       // Small pop-up notifications
  // Tooltip      // Tooltips for elements (requires @popperjs/core)
} from "bootstrap";

window.Modal = Modal;

/**
 * Swiper
 */

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.Swiper = Swiper;

/**
 * Modules
 */

import navbar from "./js/navbar";
import swiperSlider from "./js/swiperSlider";
import modalGallery from "./js/modalGallery";
import downloadGallery from "./js/downloadGallery";

document.addEventListener('DOMContentLoaded', () => {
  navbar();
  swiperSlider();
  modalGallery();
  downloadGallery();
})


document.querySelectorAll('.post__text br').forEach(br => {
  const hr = document.createElement('hr');
  hr.className = 'styled-break';
  br.parentNode.replaceChild(hr, br);
});